<section class="section banner">
  <div [@bannerTrigger] class="container">
    <div class="section-box-banner">
      <div class="content">
        <div>
          <h1>{{ "Banner.Pretitle" | translate }}</h1>
        </div>
        <div class="banner-title">
          <h2>Arthur Valente.</h2>
          <h3>Software Developer</h3>
        </div>
        <div class="banner-description">
          <p
            [innerHTML]="
              interpolateYears(
                ('Banner.Description'
                  | translate : { years: yearsOfExperience })
              )
            "
            class="mt-4"
          ></p>
        </div>
      </div>
      <div class="div-btn-banner">
        <a
          (click)="
            analyticsService.sendAnalyticEvent(
              'click_send_mail',
              'banner',
              'email'
            )
          "
          href="mailto:arthur.valente333@gmail.com"
          target="_black"
          class="main-btn"
        >
          {{ "Banner.ActionBtn" | translate }}
        </a>
        <a (click)="downloadCV()" target="_black" class="main-btn">
          {{ "Header.cvBtn" | translate }}
        </a>
      </div>
    </div>
  </div>
</section>
